import React, { useEffect, useRef } from 'react'

import { attachWebmAudioDurationFix } from 'utils/fixWebmAudioDuration'

import * as S from './styles'

interface Props {
  src: string
  className?: string
  variant?: 'preview' | 'message'
}

const ChatAudioPlayer: React.FC<Props> = ({
  src,
  className,
  variant = 'message',
}) => {
  const audioRef = useRef<HTMLAudioElement>(null)

  useEffect(() => {
    const el = audioRef.current
    if (!el || !src) return

    el.load()
    return attachWebmAudioDurationFix(el)
  }, [src])

  const Player =
    variant === 'preview' ? S.AudioPreviewPlayer : S.AudioMessagePlayer

  return (
    <S.AudioPlayerShell className={className}>
      <Player ref={audioRef} controls preload="metadata" src={src} />
    </S.AudioPlayerShell>
  )
}

export default ChatAudioPlayer
